import {
    CustomPIXIComponent,
} from "react-pixi-fiber";

import { IClip } from "../../api";

interface IProps {
    clip: IClip,
    zoom: number,
    offsetX: number,
}

export const Clip = CustomPIXIComponent<IProps, PIXI.Graphics>({
    customApplyProps: (instance, _2, props) => {
      const {
        clip,
        zoom,
        offsetX,
      } = props;
      const {
          duration,
          start,
      } = clip;

      instance.clear();

      if (!duration || !start) {
          return;
      }
      
      const width = duration * zoom;
      const x = start * zoom + offsetX;

      instance.beginFill(0x000000, 0.4);
      instance.drawRoundedRect(0, 0, width, 40, 5);
      instance.endFill();

      instance.position.set(x, 85);
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'Clip');

export default Clip;



// WEBPACK FOOTER //
// ./src/components/Player/Clip.tsx